import { createCustomError } from '@ori/error';

import { JSON_NOT_PROVIDED, JSON_NOT_VALID } from '../constants';

export const SafeParseJsonError = createCustomError('SafeParseJsonError', {
  JSON_NOT_PROVIDED,
  JSON_NOT_VALID: `${JSON_NOT_VALID}
  {0}: {1}
  {2}
  `,
});

/**
 * Safely converts a JSON string into an object.
 * Throws error if providen string is empty (error: JSON_NOT_PROVIDED) or contains invalid JSON (error: JSON_NOT_VALID).
 * @param jsonString A JSON string.
 * @returns Converted a JSON string into an object.
 */
export function safeParseJson<T>(jsonString: string) {
  if (!jsonString) {
    throw new SafeParseJsonError('JSON_NOT_PROVIDED');
  }

  try {
    return JSON.parse(jsonString) as T;
  } catch (error) {
    const { name, message } = error as Error;

    throw new SafeParseJsonError('JSON_NOT_VALID', { messageParameters: [name, message, jsonString] });
  }
}
